import { useStore } from '@/store'

export function usePermission(pageName: string, handleName: string) {
  const store = useStore()
  const permissions = store.state.login.permissions
  const verifyPermission = `sys:${pageName}:${handleName}`
  return !!permissions.find((item) => item === verifyPermission)
}

export function usePermissionWithAll(permission: string) {
  const store = useStore()
  const permissions = store.state.login.permissions
  const verifyPermission = `sys:${permission}`
  return !!permissions.find((item) => item === verifyPermission)
}
